import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { ActorService } from '../../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController } from '../../../../../models/actor/actor';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { AppFeaturesList } from '../../../../../constants/constants';
import { routerTransition } from '../../../../../animations/router.animations';
//import  './profilesteps.js';

declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

@Component({
  selector: 'myidentities',
  templateUrl: './myidentities.component.html',
  styleUrls: ['./myidentities.component.scss']
  , animations: [routerTransition()]
})

export class MyIdentitiesComponent implements OnInit, AfterViewInit {


  public isRequesting: boolean = false;

  public ApiResData: ApiResponseModel;

  @Input() ActorCode: number = 0;


  //
  public IsSetAccessRights: boolean;




  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;


  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    if (this.ActorCode <= 0) {
      this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }



    this.onSetFeatureAccessConfig();


  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {




    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())



    //

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }


    this.IsSetAccessRights = true;





    //
  }
  //

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }




}
